import React, { Fragment, useContext, useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { useUIMode } from "../hooks/useUIMode";
import { UserContext } from "../UserContext";
import { hasAnyPerm } from '../utils/uiUtils';
import { useTranslation } from 'react-i18next';
import { axiosAuth_LEASE_MGMT_API } from '../utils/AxoisUtilComponent';
import TemplateListView    from "./TemplateListView";
import FloorAdminDetailsView from "./FloorAdminDetailsView";
import FloorAdminNewView     from "./FloorAdminNewView";


const FloorAdmin = () => {

  const { t }    = useTranslation(["common"]);
  const { user } = useContext(UserContext);
  const navigate = useNavigate();

  const { uiMode, setUIMode, objDetails, setObjDetails } = useUIMode('LIST');

  const PAGE_STATE_STORAGE_KEY = "FloorAdmin.pageState";
  const defaultPageState = {
    searchTerms: null,
    sortCol: null,
    sortDir: null,
    perPage: 25,
    currPage: 1
  };

  const [pageState, setPageState] = useState(() => {
    try {
      const savedPageState = sessionStorage.getItem(PAGE_STATE_STORAGE_KEY);
      return savedPageState
        ? { ...defaultPageState, ...JSON.parse(savedPageState) }
        : defaultPageState;
    } catch (error) {
      return defaultPageState;
    }
  });

  useEffect(() => {
    sessionStorage.setItem(PAGE_STATE_STORAGE_KEY, JSON.stringify(pageState));
  }, [pageState]);

  // Initialize state
  useEffect(() => {

    // Route to home page if not authorized
    if (!hasAnyPerm(user, ["BuildingAdminGeneralWriteAccess"], true)) {
      navigate("/AdminHome/Dashboard", {
        state: {
          //...values
          target: 'Dashboard'
        }
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  // ----- Data Table stuff -----

  const tableColumns = [
    {
      igcColumnType: 'PRIMARY_ID',
      igcFieldName: 'name',
      name: t("I18N_Name"),
      sortable: true,
      sortField: 'name',
      grow: 2,
      cell: null
    },
    {
      name: t("I18N_Description"),
      selector: row => row.description,
      grow: 2.5,
      wrap: true
    },
    {
      name: t("I18N_Fl_loc_code"),
      selector: row => row.floorLocCode,
      sortable: true,
      sortField: 'floorLocCode',
      grow: 2,
      wrap: true
    },
    {
      name: t("I18N_GFA"),
      selector: row => row.grossFloorArea,
      sortable: true,
      sortField: 'grossFloorArea',
      grow: 1,
      wrap: true
    },
    {
      name: t("I18N_SFA"),
      selector: row => row.saleableFloorArea,
      sortable: true,
      sortField: 'saleableFloorArea',
      grow: 1,
      wrap: true
    },
    {
      name: t("I18N_Status"),
      selector: row => row.status,
      sortable: true,
      sortField: 'status',
      wrap: true
    },
    {
      name: t("I18N_Sort_seq_num"),
      selector: row => row.sortSequenceNum,
      sortable: true,
      sortField: 'sortSequenceNum',
      grow: 2,
      wrap: true
    },
    {
      igcColumnType: 'DELETE',
      name: '',
      selector: row => row.id,
      grow: 0.5,
      cell: null
    }
  ];

  // ----- END - Data Table stuff -----


  return (
    <Fragment>

      {(uiMode === 'LIST')    ? <TemplateListView pageState={pageState}
                                                  axiosAPI={axiosAuth_LEASE_MGMT_API} apiObjName={'prop-floors'}
                                                  listPageTitle={t("I18N_Prop_Floor_Management")}
                                                  newObjTooltip={t("I18N_TIP_New_prop_floor")}
                                                  searchTooltip={t("I18N_TIP_Search_complex")}
                                                  deleteConfirmDialogTitle={t("I18N_Floor_delete_confirm")}
                                                  deleteObjTooltip={t("I18N_TIP_Delete_prop_floor")}
                                                  tableColumns={tableColumns}
                                                  deletePermission={'BuildingAdminGeneralDeleteAccess'}
                                                  onUIMode={setUIMode}
                                                  onSetPageState={setPageState}
                                                  onSetObjDetails={setObjDetails} /> : null}
      {(uiMode === 'DETAILS') ? <FloorAdminDetailsView onUIMode={setUIMode} objDetails={objDetails} />                  : null}
      {(uiMode === 'NEW')     ? <FloorAdminNewView     onUIMode={setUIMode} />                                          : null}

    </Fragment>
  )
}

export default FloorAdmin;
